(($) => {
  function load_taxonomies(spinner = false) {
    if (jQuery('input#sqpx_metabox_post_type').length > 0) {
      var post_type = jQuery('input#sqpx_metabox_post_type').val();
    }

    if (jQuery('select#sqpx_metabox_post_type').length > 0) {
      var post_type = jQuery('select#sqpx_metabox_post_type')
        .children('option:selected')
        .val();
    }

    jQuery.ajax({
      url: sqpxSubscriptionsTax.admin_ajax_url,
      data: {
        post_id: sqpxSubscriptionsTax.post_id,
        post_type,
        taxonomies: sqpxSubscriptionsTax.taxonomies,
        action: 'js_load_taxonomies',
      },
      dataType: 'json',
      beforeSend() {
        if (spinner) {
          jQuery('.sqpx-spinner').removeClass('sqpx-hidden');
        }
      },
      complete() {
        jQuery('.sqpx-spinner').addClass('sqpx-hidden');
      },
      success(data) {
        if (data) {
          // Each Taxonomy
          jQuery.each(data, function () {
            var data_tax;
            var taxonomy_row;
            var select2_taxonomies;

            var data_tax = this;
            var taxonomy_row = jQuery(
              `<div class="[ c-subscription-form__field  c-subscription-form__field--taxonomies ]"><label class="[ c-subscription-form__label ]" for="sqpx_metabox_${data_tax.taxonomy_slug}">${data_tax.taxonomy_name}</label>`
            ).appendTo('#sqpx-subscription-form .js-sqpx-taxonomies');

            var select2_taxonomies = jQuery(data_tax.html).appendTo(
              jQuery(taxonomy_row)
            );
            jQuery('</div>').insertAfter(jQuery(taxonomy_row));

            // Event: sqpx-loaded-taxonomies
            jQuery(document).trigger('sqpx-loaded-taxonomies', [
              select2_taxonomies,
            ]);

            // Initiate Select2
            jQuery(select2_taxonomies).select2({
              placeholder: sqpxSubscriptionsTax.select2_placeholder,
            });
          });
        }
      },
    });
  }

  function destroy_select2_fields() {
    jQuery('.c-subscription-form__field--taxonomies').each(function () {
      jQuery(this).closest('.c-subscription-form__select').select2('destroy');
      jQuery(this).remove();
    });
  }

  // On Window Load
  jQuery(window).on('load', () => {
    // Load taxonomies on page load when the post type field is hidden
    if (
      jQuery('.js-subscription-form').length > 0 &&
      jQuery('.js-subscription-form .js-sqpx-taxonomies').length > 0
    ) {
      load_taxonomies();
    }
  });

  jQuery('.js-subscription-form').on('formReset', () => {
    destroy_select2_fields();
  });

  // On Document Ready
  jQuery(document).ready(() => {
    const spinner = true;

    if (
      jQuery('.js-subscription-form').length > 0 &&
      jQuery('.js-subscription-form .js-sqpx-taxonomies').length > 0
    ) {
      jQuery('#sqpx_metabox_post_type').on('change', () => {
        destroy_select2_fields();
        load_taxonomies(spinner);
      });
    }

    if (jQuery('.js-subscription-form').length > 0) {
      jQuery('.js-subscription-form .sqpx-hidden').each(function () {
        jQuery(this).hide();
      });
    }
  });
})(jQuery);
